import { VerticalContainer } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';
import PanelSection from 'components/PanelSection';

import Sparkline from 'pages/MaintenancePage/components/Sparkline';
import WarningEntry from 'pages/MaintenancePage/components/WarningEntry';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const TabPanelWarnings: FunctionComponent<Props> = ({
    className = '',
    drone,
    testId = TEST_ID
}) => {
    const { FAULT_HISTORY, FLEET_HAPPY } = useTranslation();
    const topSeverity = drone.status === 'critical' ? 'critical' : 'caution';
    const historyTotal = drone.faultHistory.reduce((sum, value) => sum + value, 0);
    const hasWarnings = drone.topWarning !== null || drone.watching.length > 0;

    return (
        <VerticalContainer className={className} testId={testId}>
            {!hasWarnings && <EmptyState text={FLEET_HAPPY} />}

            {drone.topWarning && <WarningEntry severity={topSeverity} text={drone.topWarning} />}

            {drone.watching.map(entry => (
                <WarningEntry key={entry} severity='watching' text={entry} />
            ))}

            <PanelSection count={historyTotal} text={FAULT_HISTORY}>
                <Sparkline label={FAULT_HISTORY} values={drone.faultHistory} />
            </PanelSection>
        </VerticalContainer>
    );
};

export default TabPanelWarnings;
